export default __webpack_public_path__ + "static/media/gallery25.895cee89.webp";